import * as React from 'react';
import {DataGrid, GridColDef, GridValueGetterParams} from '@material-ui/data-grid';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import {Delete} from "@material-ui/icons";

const columns: GridColDef[] = [
        {field: 'id', headerName: 'ID', width: 90},
        {
            field: 'firstName',
            headerName: 'First name',
            width: 150,
            editable: true,
        },
        {
            field: 'lastName',
            headerName: 'Last name',
            width: 150,
            editable: true,
        },
        {
            field: 'age',
            headerName: 'Age',
            type: 'number',
            width: 110,
            editable: true,
        },
        {
            field: 'fullName',
            headerName: 'Full name',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 160,
            valueGetter: (params: GridValueGetterParams) =>
                `${params.getValue(params.id, 'firstName') || ''} ${
                    params.getValue(params.id, 'lastName') || ''
                }`,
        },
        {
            field: 'category',
            headerName: 'Category',
            width: 150,
            editable: true,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 140,
            renderCell: (params: GridValueGetterParams) =>
                (
                    <div>
                        <Fab color="primary" aria-label="edit" size={'small'}>
                            <EditIcon/>
                        </Fab>
                        <Fab color="secondary" aria-label="delete" size={'small'}>
                            <Delete/>
                        </Fab></div>
                ),
        }

    ]
;

const rows = [
    {id: 1, lastName: 'Admin', firstName: 'Admin', age: null, category: 'admin'},
    {id: 2, lastName: 'Nowak', firstName: 'Joseph', age: null, category: 'parent'},
    {id: 3, lastName: 'Nowak', firstName: 'Jacek', age: 11, category: 'kid'},
    {id: 4, lastName: 'Nowak', firstName: 'Agatka', age: 12, category: 'kid'},
];

export default function UserList() {
    return (
        <div style={{height: 400, width: '100%'}}>
            <DataGrid
                rows={rows}
                columns={columns}
                pageSize={5}
                checkboxSelection
                disableSelectionOnClick
            />
        </div>
    );
}

